import React from 'react';
import classNames from 'classnames';
import './DesignerHeader.less';
import { IconButton } from 'components/buttons/IconButton';
import { Spinner } from 'components/Spinner';
import { Icon } from 'components/icons/Icon';

export interface IDesignerHeaderProps extends React.HTMLProps<HTMLHeadElement> {
  title: string;
  isLoading?: boolean;
  loadingText?: string;
  breadcrumbs?: string[];
  onClose: () => void;
  children?: React.ReactNode;
  iconClassName?: string;
  iconTitle?: string;
}

function buildBreadCrumbsString(breadcrumbs: string[]): string {
  return `[  ${[...breadcrumbs].join('  /  ')}  ]`;
}

/**
 * Header Component which is common for all designers
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function DesignerHeader({
  title,
  className,
  breadcrumbs,
  loadingText,
  onClose,
  children,
  isLoading,
  iconClassName,
  iconTitle,
  ...otherProps
}: IDesignerHeaderProps) {
  const showBreadCrumbs: boolean = !!breadcrumbs?.length;

  return (
    <header className={classNames('dpc-designer-header', className)} {...otherProps}>
      <div className="dpc-designer-header__row dpc-designer-header__row--title">
        <div className="dpc-designer-header__path">
          {iconClassName && (
          <Icon
            className={classNames('dpc-designer-header__icon', iconClassName)}
            size={'large'}
            title={iconTitle}
          />)}
          <h2 title={title} className="dpc-designer-header__title">
            {title}
          </h2>
          {showBreadCrumbs && (
            <h3 title={buildBreadCrumbsString(breadcrumbs ?? [])} className="dpc-designer-header__breadcrumbs">
              {buildBreadCrumbsString(breadcrumbs ?? [])}
            </h3>
          )}
        </div>

        <div className="dpc-designer-header__right">
          {isLoading && (
            <div className="dpc-designer-header__loading">
              <Spinner size={20} />
              <div className="dpc-designer-header__loading-text">{loadingText}</div>
            </div>
          )}
          <IconButton
            iconSize={'input'}
            iconClassName="dpc-designer-header__close"
            title="Close Designer"
            onClick={onClose}
          />
        </div>
      </div>
      {!!children && (
        <div className={classNames('dpc-designer-header__row', 'dpc-designer-header__row--actions')}>{children}</div>
      )}
    </header>
  );
}
